import React from 'react';
import { ThumbFrame, INK } from './thumbFrame';

/** Handwriting recognition — cursive ink converted to clean typed text. */
const HandwritingThumb: React.FC = () => (
  <ThumbFrame label="Handwriting Recognition System">
    {/* Handwriting card */}
    <rect x="40" y="86" width="132" height="128" rx="10" fill="#ffffff" stroke={INK} strokeWidth="1.8" />
    {/* Cursive stroke that draws itself */}
    <path
      d="M60 150 q10 -26 20 -6 t18 -2 q8 -18 16 -2 t18 -4 q6 14 16 4 M148 132 l10 30"
      fill="none"
      stroke={INK}
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="240"
      strokeDashoffset="240"
    >
      <animate attributeName="stroke-dashoffset" values="240;0;0;240" keyTimes="0;0.5;0.85;1" dur="4s" repeatCount="indefinite" />
    </path>
    {/* baseline */}
    <line x1="58" y1="188" x2="154" y2="188" stroke={INK} strokeWidth="1" opacity="0.15" />

    {/* Arrow */}
    <path d="M186 150 H214 M206 141 l10 9 l-10 9" fill="none" stroke={INK} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />

    {/* Recognized text card */}
    <rect x="228" y="86" width="132" height="128" rx="10" fill="#ffffff" stroke={INK} strokeWidth="1.8" />
    <text x="248" y="146" fontFamily="'JetBrains Mono', monospace" fontSize="30" fontWeight="700" fill={INK}>Aa</text>
    <rect x="248" y="162" width="92" height="7" rx="3.5" fill={INK} opacity="0.14" />
    <rect x="248" y="176" width="72" height="7" rx="3.5" fill={INK} opacity="0.14" />
    <rect x="248" y="190" width="84" height="7" rx="3.5" fill={INK} opacity="0.14" />
  </ThumbFrame>
);

export default HandwritingThumb;
